import React from 'react';
import style from './CustomSelect.module.scss';

interface CustomSelectFieldProps {
  className?: string;
  options: string[];
  name: string;
  placeholder?: string;
  error?: boolean;
  onChange?: any;
  value?: string;
  ref?: any;
  control?: any;
}

const CustomSelectField: React.FC<CustomSelectFieldProps> = ({
  className,
  options,
  name,
  placeholder,
  onChange,
  value,
  control,
}) => {
  return (
    <div>
      <select
        name={name}
        onChange={onChange}
        value={value}
        className={[style.customSelect, className].join(' ')}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option, index) => {
          return (
            <option
              selected={option === control(name)}
              className={style.option}
              key={index}
              value={option}
            >
              {option}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default CustomSelectField;
